import { defaultPropertyDefinitions } from "@buildwithflux/constants";
import { values } from "lodash";
import { booleanClassifier } from "../../../../property";
import { BOMFormat } from "./base";
/**
 * Elecrow BOM format
 * https://www.elecrow.com/media/product/BOM_Template.xlsx
 */
export class ElecrowFormat extends BOMFormat {
    static manufacturer = "Elecrow";
    static columns = {
        "*Reference": (item) => item.designators.join(", "),
        "*Manufacturer Part number": "mpn",
        "*QTY": "quantity",
        "*Original": (item) => {
            const rawAllowSubstituteValue = values(item.elementProperties)[0]?.[defaultPropertyDefinitions.allow_substitutes?.label];
            const rawSubstituteMpnValue = values(item.elementProperties)[0]?.[defaultPropertyDefinitions.substitute_mpn?.label];
            if (!rawAllowSubstituteValue) {
                return "";
            }
            const allowSubstituteValue = booleanClassifier(String(rawAllowSubstituteValue));
            return allowSubstituteValue || !!rawSubstituteMpnValue ? "N" : "Y";
        },
        Description: (item) => {
            const rawSubstituteMpnValue = values(item.elementProperties)[0]?.[defaultPropertyDefinitions.substitute_mpn?.label];
            if (rawSubstituteMpnValue) {
                return `${item.description} \n\n Substitute MPN: ${rawSubstituteMpnValue}`;
            }
            else {
                return item.description;
            }
        },
        "Purchase Link": (item) => {
            return (values(item.elementProperties)[0]?.[defaultPropertyDefinitions.purchase_url?.label] ||
                values(item.elementProperties)[0]?.[defaultPropertyDefinitions.product_info_url?.label] ||
                "");
        },
    };
}
//# sourceMappingURL=Elecrow.js.map